import Navbar from "./Navbar";
import Post from "./Post";
import { Route, Routes } from 'react-router-dom';
import About from "./About";
import Contact from "./Contact";
import Home from "./Home";
import NotFound from "./NotFound";
import Post2 from "./Post2.js"
import Post3 from "./Post3.js"

// import whatever component you want to embed
import TypesPie from "./ReactorTypesCanvas/TypesPie.js"
import Temp from "./ReactorTypesCanvas/Temp.js"

function Layout({ children }) {
  return (
    <div>
      <Navbar />
      {children}
    </div>
  );
}

function App() {
  return (
    <Routes>
      {/* Embed routes - no navbar, no wrapper */}
      <Route path="/embed/TypesPie" element={<TypesPie isEmbed={true} />} />
      <Route path="/embed/Temp" element={<Temp isEmbed={true} />} />

      {/* Normal routes - wrapped in Layout */}
      <Route path="/" element={<Layout><Home /></Layout>} />
      <Route path="/home" element={<Layout><Home /></Layout>} />
      <Route path="/post" element={<Layout><Post /></Layout>} />
      <Route path="/ReactorTypes" element={<Layout><Post2 /></Layout>} />
      <Route path="/RuiningNuclear" element={<Layout><Post3 /></Layout>} />
      <Route path="/about" element={<Layout><About /></Layout>} />
      <Route path="/contact" element={<Layout><Contact /></Layout>} />
      <Route path="*" element={<Layout><NotFound /></Layout>} />
    </Routes>
  );
}

export default App;